const open_navigation_faq = (e,body,arrow) =>{
    
    expandElement(e,
    e.querySelector("."+body),
    e.querySelector("."+arrow),
    e.parentElement,
    "active")

}


function expandElement(e,body,arrow,parent,collapseClass) {

arrow.querySelector('#Capa_1').classList.toggle("is-visible")
arrow.querySelector('#Capa_2').classList.toggle("is-visible")

parent.classList.toggle(collapseClass)
e.classList.toggle(collapseClass)
body.style.height = '';
body.style.transition = 'none';

let startHeight = window.getComputedStyle(body).height;

// Remove the collapse class, and force a layout calculation to get the final height
body.classList.toggle(collapseClass);
let height = window.getComputedStyle(body).height;

// Set the start height to begin the transition
body.style.height = startHeight;

// wait until the next frame so that everything has time to update before starting the transition
requestAnimationFrame(() => {
    body.style.transition = '';
    
    requestAnimationFrame(() => {
        body.style.height = height
    })
})

// Clear the saved height values after the transition
body.addEventListener('transitionend', () => {
    body.style.height = '';
    body.removeEventListener('transitionend', arguments.callee);
}); 
}